import styles from '../../RiskIndicators.module.scss';
import { useRiskIndicatorStates } from '../../useRiskIndicatorStates';
import { TYPES } from '../../RiskIndicatorConstants';
import { Row } from '../../RiskIndicators';
import { Header } from './RiskIndicatorHeaders';
import { normalizeNameKey } from '../../../../utils/utils';
import { getRiskCellStyle } from '../../riskIndicatorUtils';
import { useAppDispatch } from '../../../../app/hooks';
import { removeTooltipContent, setTooltipContent } from '../../../../store/tooltip/tooltip_actions';

interface RiskIndicatorRowsProps {
    rows: Row[];
    setRows: React.Dispatch<React.SetStateAction<Row[]>>;
    headers: Header[];
    isPDFReport?: boolean;
    onOpenRegulatoryRisk?: (row: Row, checkType: string) => void;
}

const RiskIndicatorRows = ({ rows, setRows, headers, isPDFReport = false, onOpenRegulatoryRisk }: RiskIndicatorRowsProps) => {
    const { getRowImage, getRiskIndicator } = useRiskIndicatorStates({
        rows,
        setRows,
        autoFetch: false,
    });
    const dispatch = useAppDispatch();

    return (
        <>
            {rows?.map((row, index) => (
                <div
                    className={styles.TableRow}
                    key={index}
                    data-ri-director={normalizeNameKey(row?.name)}
                    data-ri-din={row?.identifier ?? ''}
                >
                    <div className={styles.StickyRows}>
                        <div className={styles.Name}>
                            <span>{getRowImage(row?.type)}</span>
                            <span
                                // Cell truncates — reveal full name + designation on hover via the shared
                                // tooltip component (matches Legal Cases).
                                className={styles.NameSpan}
                                onMouseEnter={(e) => {
                                    if (isPDFReport) return;
                                    const designationSuffix =
                                        row?.type === TYPES.INDIVIDUAL && row?.designation ? ` (${row.designation})` : '';
                                    dispatch(
                                        setTooltipContent({
                                            content: `${row?.name ?? ''}${designationSuffix}`,
                                            target: e.currentTarget,
                                            placement: 'top',
                                        }),
                                    );
                                }}
                                onMouseLeave={() => removeTooltipContent(dispatch)}
                            >
                                {row?.name}
                                {row?.type === TYPES.INDIVIDUAL && row?.designation && (
                                    <span className={styles.DesignationText}> ({row.designation})</span>
                                )}
                            </span>
                        </div>
                    </div>
                    {headers.map((header, headerIndex) => (
                        <div className={styles.TableRowItem} key={headerIndex} style={getRiskCellStyle(row, header.key)}>
                            {getRiskIndicator(row?.riskProfile?.[header.key], row, header.key, onOpenRegulatoryRisk)}
                        </div>
                    ))}
                </div>
            ))}
        </>
    );
};

export default RiskIndicatorRows;
